
import React from 'react';
import ReactModal from "react-modal";
import "./Schedule.css";
import { useGlobalContext } from "../../context";
import CloseIcon from "@mui/icons-material/Close";
import { holidayDelete, sceduleDelete } from "../../api";

function ScheduleDelete({ getScheduls }) {

    const {
        concretSchedule,
        setConcretSchedule,
        openDeleteSchedule,
        setOpenDeleteSchedule
    } = useGlobalContext()

    const updatData = async (data) => {
        if (data) {
            await getScheduls();
        }
    }

    const deleteThisSchedule = async () => {
        if (concretSchedule.id) {
            const deleteHolData = await holidayDelete(concretSchedule.id);
            await updatData(deleteHolData.data);
            setConcretSchedule();
            setOpenDeleteSchedule(false);
        }

        else if (concretSchedule.scheduleId) {
            const deleteScheduleData = await sceduleDelete(concretSchedule.scheduleId);
            await updatData(deleteScheduleData.data);
            setConcretSchedule();
            setOpenDeleteSchedule(false);
        }
    }

    return(
        <ReactModal
            isOpen = { openDeleteSchedule }
            onRequestClose = { async () => {
                await setConcretSchedule();
                setOpenDeleteSchedule(false)
            }}
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '580px',
                    maxHeight: "230px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                }
            }}
        >
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    display: window.innerWidth >= 620 ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
            >
                <CloseIcon
                    style = {{
                        cursor: "pointer",
                        color: "rgba(0,0,0,0.5)"
                    }}
                    onClick = { async () => {
                        await setConcretSchedule();
                        setOpenDeleteSchedule(false)
                    }}
                />
            </div>
            <div className = "deleteUserBox">
                <h4 className = "deleteUserHeatText">DELETE POST</h4>
                <span className = "deleteWindowMessage">Do You Want to Delete this Post ?</span>
                <button className = "deleteUserBtn" onClick = { deleteThisSchedule }>Delete</button>
            </div>
        </ReactModal>
    )
}

export default ScheduleDelete
